import { createSlice } from "@reduxjs/toolkit";

export const peakHoursReportSlice = createSlice({
	name: "peakHoursReport",
	initialState: {
		totalDoors: {
			small: 0,
			medium: 0,
			large: 0,
			xl: 0,
		},
	},
	reducers: {
		setTotalDoors: (state, actions) => {
			state.totalDoors = actions.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setTotalDoors } = peakHoursReportSlice.actions;

export default peakHoursReportSlice.reducer;
